export default __webpack_public_path__ + "static/media/pms-homepage-mob-banner.08161220.jpg";